import dateFns from 'date-fns';
import _ from 'lodash';

export const DATE_UNIT = {
  millisecond: 'Millisecond',
  second: 'Second',
  minute: 'Minute',
  hour: 'Hour',
  day: 'Day',
  week: 'Week',
  month: 'Month',
  quarter: 'Quarter',
  year: 'Year'
};

export function getHours(startHour, endHour) {
  let curDate = dateFns.startOfHour(new Date());
  let hours = [];

  for (let hourIndex = startHour; hourIndex <= endHour; hourIndex++) {
    let date = dateFns.setHours(curDate, hourIndex);
    hours.push(date);
  }

  return hours;
}

export function getRangeDates(startDate, endDate, dateUnit) {
  let curDate = dateFns.startOfDay(startDate);
  let dates = [];
  let addDateUnit = dateFns[`add${dateUnit}s`];

  while (dateFns.isBefore(curDate, endDate)) {
    dates.push(curDate);
    curDate = addDateUnit(curDate, 1);
  }

  return dates;
}

export function getDailyRangeDates(targetDate, isIncludePriorDay = false) {
  if (isIncludePriorDay) {
    return [dateFns.addDays(targetDate, -1), targetDate];
  }

  return [targetDate];
}

export function getWeeklyRangeDates(targetDate, isIncludePriorDay = false) {
  let startDay = dateFns.startOfWeek(targetDate);
  let endDay = dateFns.endOfWeek(targetDate);

  if (isIncludePriorDay) {
    startDay = dateFns.addDays(startDay, -1);
  }

  return getRangeDates(startDay, endDay, DATE_UNIT.day);
}

export function getMonthlyRangeDates(targetDate, isCalendar) {
  const startDay = dateFns.startOfMonth(targetDate);
  const endDay = dateFns.endOfMonth(targetDate);

  if (!isCalendar) {
    return getRangeDates(startDay, endDay, DATE_UNIT.day);
  }

  let calendarStartDay = dateFns.startOfWeek(startDay);
  let calendarEndDay = dateFns.endOfWeek(endDay);

  if (dateFns.differenceInDays(calendarEndDay, calendarStartDay) < 36) {
    calendarEndDay = dateFns.addWeeks(calendarEndDay, 1);
  }

  return getRangeDates(calendarStartDay, calendarEndDay, DATE_UNIT.day);
}

export function isWithinDateRange(date, firstDate, lastDate) {
  let startOfFirstDate = dateFns.startOfDay(firstDate);
  let endOfLastDate = dateFns.endOfDay(lastDate);

  return dateFns.isWithinRange(date, startOfFirstDate, endOfLastDate);
}

export function getBookingsInRange(
  bookings,
  firstDate,
  lastDate,
  sortOption = 'asc'
) {
  let filteredBooking = bookings.filter(booking =>
    isWithinDateRange(booking.dt, firstDate, lastDate)
  );

  return _.orderBy(filteredBooking, ['dt'], [sortOption]);
}

export function getBookingsAndWaitingInRange(
  bookings,
  firstDate,
  lastDate,
  sortOption = 'asc'
) {
  let filteredBooking = bookings.filter(booking =>
    isWithinDateRange(booking.dt, firstDate, lastDate)
  );

  return _.orderBy(filteredBooking, ['dt'], [sortOption]);
}

export function getBookingsOutOfRange(
  bookings,
  firstDate,
  lastDate,
  sortOption = 'asc'
) {
  let filteredBooking = bookings.filter(
    booking => !isWithinDateRange(booking.dt, firstDate, lastDate)
  );

  return _.orderBy(filteredBooking, ['dt'], [sortOption]);
}

export function convertDateToDatetimeRange(DateRange) {
  return {
    start: dateFns.startOfDay(DateRange.start),
    end: dateFns.endOfDay(DateRange.end)
  };
}

export function areDateRangesOverlapping(initialDateRange, comparedDateRange) {
  let initialDatetimeRange = convertDateToDatetimeRange(initialDateRange),
    comparedDatetimeRange = convertDateToDatetimeRange(comparedDateRange);

  return dateFns.areRangesOverlapping(
    initialDatetimeRange.start,
    initialDatetimeRange.end,
    comparedDatetimeRange.start,
    comparedDatetimeRange.end
  );
}

export function convertStringDigitToDate(value) {
  const year = value.slice(0, 4);
  const month = value.slice(4, 6);
  const day = value.slice(6, 8);

  return new Date(`${year}-${month}-${day}`);
}

export function setTimeOnDate(date, time) {
  if (!time) {
    return null;
  }

  let [hours, minutes] = time.split(':');

  return dateFns.setMinutes(dateFns.setHours(date, hours), minutes);
}
